export const EVENTS = {
  CURATOR_LINK_OPEN_IN_APP_CLICKED: 'curator_link_open_in_app_clicked',

  // PDP V2 Tracking
  PDP_V2_VIEW: 'pdp_v2_view',
  PDP_V2_BUY_NOW_CLICK: 'pdp_v2_buy_now_click',
  PDP_V2_SHARE_CLICK: 'pdp_v2_share_click',
  PDP_V2_TRY_ON_CLICK: 'pdp_v2_try_on_click',
  PDP_V2_SIZE_SHEET_OPEN: 'pdp_v2_size_sheet_open',
  PDP_V2_SIZE_SELECTED: 'pdp_v2_size_selected',
  PDP_V2_SIZE_SHEET_CLOSE: 'pdp_v2_size_sheet_close',
  PDP_V2_SIZE_SHEET_CONTINUE: 'pdp_v2_size_sheet_continue',
  PDP_V2_REEL_CLICK: 'pdp_v2_reel_click',
  PDP_V2_POLICY_ACCORDION_CLICK: 'pdp_v2_policy_accordion_click',

  // Razorpay Web Hook / Flow Tracking
  ORDER_CREATED: 'order_created',
  RAZORPAY_OPENED: 'razorpay_opened',
  RAZORPAY_SUCCESS: 'razorpay_success',
  PAYMENT_CONFIRMED: 'payment_confirmed',
  RAZORPAY_CANCELLED: 'razorpay_cancelled',
  ORDER_CREATE_FAILED: 'order_create_failed',
  RAZORPAY_FAILURE: 'razorpay_failure',
  PAYMENT_CONFIRM_FAILED: 'payment_confirm_failed',

  // Order Placed screen Tracking
  ORDER_PLACED_VIEW: 'order_placed_view',
  ORDER_PLACED_CONTINUE_CLICK: 'order_placed_continue_click',
  ORDER_PLACED_ACTION_CLICK: 'order_placed_action_click',
} as const;

export const PROPERTIES = {
  CURATOR_NAME: 'curator_name',
  INSTAGRAM_ACCOUNT_NAME: 'instagram_account_name',
  POST_ID: 'post_id',
  CURATION_ID: 'curation_id',
  EXPERIMENT: 'experiment',
  DISTINCT_ID: 'distinct_id',

  // Custom Event Properties
  PRODUCT_ID: 'product_id',
  PRODUCT_NAME: 'product_name',
  PRICE: 'price',
  BRAND: 'brand',
  IS_AVAILABLE: 'is_available',
  HAS_SIZES: 'has_sizes',
  SELECTED_SIZE: 'selected_size',
  SIZE: 'size',
  VIDEO_ID: 'video_id',
  SECTION: 'section',
  IS_OPEN: 'is_open',
  AVAILABLE_SIZES: 'available_sizes',

  // Checkout and Order Properties
  GUEST_ORDER_ID: 'guest_order_id',
  ORDER_ID: 'order_id',
  STATUS: 'status',
  AMOUNT: 'amount',
  ITEM_COUNT: 'item_count',
  PAYMENT_MODE: 'payment_mode',
  PRODUCT_IDS: 'product_ids',
  ACTION: 'action',
  FAILURE_REASON: 'failure_reason',
  PAYMENT_ID: 'payment_id',
} as const;
